import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues = {
  typeDoc: '',
  code: '',
  typeRights: '',
  description: '',
  mode: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const TypeDocInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

TypeDocInitializer.displayName = 'Type Document initializer component';

export default TypeDocInitializer;
